import { TranslationsContext } from '@teliaee/telia-translate';
import React, { useContext } from 'react';
import InternetPacketSpeed from './InternetPacketSpeed';
import { Item } from './types';

interface InternetPacketDataLimitsProps {
  item: Item;
}

const InternetPacketDataLimits: React.FC<InternetPacketDataLimitsProps> = (props) => {
  const { translate } = useContext(TranslationsContext);
  const { item } = props;
  const { maxAmount, download, upload, title } = item;

  return (
    <React.Fragment>
      <h3 className="h4 text-bold">{title}</h3>
      {translate('internetPacketItem.maxAmount')}
      <div className="h3 text-bold text__margin-none">{maxAmount}</div>
      <InternetPacketSpeed download={download} upload={upload} />
    </React.Fragment>
  );
};

export default InternetPacketDataLimits;
